import LinkifyIt from 'linkify-it';

// Initialize linkify-it with fuzzy link detection (catches google.com without protocol)
const linkify = new LinkifyIt();

/**
 * Finds URLs in text using linkify-it for robust detection.
 * Catches: google.com, www.google.com, https://google.com, etc.
 * @returns Array of [url, startIndex] tuples
 */
const findUrlsInText = (text: string): [string, number][] => {
  const matches = linkify.match(text);

  if (!matches) {
    return [];
  }

  return matches.map((match) => [match.text, match.index]);
};

export default findUrlsInText;
